import React from "react";
import {COURSE_LIST_WIDTH} from "../../constants/cssConstants";
import searchPng from './../../assets/search.png';
import CourseLists from "../CourseLists/CourseLists";
import {CircularProgress} from "@material-ui/core";
import requests from "../../constants/requests";
import closePng from './../../assets/close.png';

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: "",
            result: [],
            isSearching: false,
            requestTimer: undefined
        }

        this.onChange = this.onChange.bind(this);
        this.request = this.request.bind(this);
    }

    onChange(e) {
        const searchText = e.target.value;
        if(this.state.requestTimer !== undefined) {
            clearTimeout(this.state.requestTimer);
        }
        this.setState({
            searchText: searchText,
            requestTimer: setTimeout(() => this.request(searchText), 500)
        });
    }

    request(courseCode) {
        this.setState({isSearching: true, requestTimer: undefined});
        fetch(requests.SEARCH(), {
            method: 'POST',
            headers: requests.HEADER(),
            body: JSON.stringify({
                token: this.props.token,
                courseCode: courseCode
            })
        }).then((res) => {
            res.json().then((response) => {
                if(!response.isTokenValid) {
                    this.props.onLogout();
                }
                if(response.success) {
                    this.setState({result: response.searchResult})
                }
                this.setState({isSearching: false})
            })
        })
    }

    render() {
        return (
            <div style={{ height: 40, width: COURSE_LIST_WIDTH, position: 'absolute', bottom: 0, right: 0,
                backgroundColor: '#747678', boxShadow: 'inset 0px 8px 8px rgba(0, 0, 0, 0.25)', borderRadius: 4,
                display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <input id={'search_input'}
                    style={{backgroundColor: 'transparent', borderWidth: 0, color: 'white', marginLeft: 10, width: 200}}
                    placeholder={"Search for a course..."}
                    onChange={this.onChange}
                   value={this.state.searchText}
                />
                {
                    this.state.requestTimer !== undefined ? <CircularProgress color={"secondary"} size={24}
                                                                              style={{marginRight: 10}} />
                    : this.state.result.length === 0 && this.state.searchText === ""
                        ? <img src={searchPng} style={{height: 24, width: 24, marginRight: 10}} />
                        : <img src={closePng} style={{height: 24, width: 24, marginRight: 10}}
                               onClick={() => {
                                   this.setState({searchText: "", result: []})
                               }}
                        />
                }
                {
                    this.state.result.length !== 0
                        && <div style={{position: 'absolute', left: 0, top: 40, zIndex: 99}}>
                            <CourseLists
                                listTitle={ "" }
                                courses={ this.state.result }
                                height={this.props.searchResultHeight}
                                fromSearchList
                                addToPlanCoursesList={this.props.addToPlanCoursesList}
                            />
                       </div>
                }
            </div>
        );
    }
}

export default Search;
